import * as React from "react";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import { OrangeTextButton } from "../../../common/OrangeTextButton";
import EditIcon from "@mui/icons-material/Edit";
import { Tooltip } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

interface MetadataTagZonesTableProps {
  metadataTagZones: any[];
  onEditClick: () => void;
}

export const MetadataTagZonesTable: React.FC<MetadataTagZonesTableProps> = ({
  metadataTagZones,
  onEditClick,
}) => {
  return (
    <div>
      <div className="pt-[10px] w-[320px]z-10">
        <OrangeTextButton
          onClick={onEditClick}
          text={
            <>
              <EditIcon fontSize="small" />
              &nbsp;Edit Tag Zones
            </>
          }
          disabled={false}
        />
      </div>
      {metadataTagZones.length > 0 && (
        <div className="pl-[5px] pt-[10px]">
          <TableContainer sx={{ width: 320, height: 320 }}>
            <Table
              sx={{
                fontFamily: "Mulish",
              }}
              stickyHeader
              size="small"
            >
              {/* <TableHead>
                            <TableRow sx={{ height: 50, borderBottom: "none" }}>
                                <TableCell
                                    sx={{
                                        fontWeight: "bold",
                                        fontFamily: "Mulish",
                                        width: "60px",
                                        padding: "8px 8px",
                                        height: 40,
                                        borderBottom: "none",
                                    }}
                                >
                                    Color
                                </TableCell>
                                <TableCell
                                    sx={{
                                        fontWeight: "bold",
                                        fontFamily: "Mulish",
                                        padding: "8px 8px",
                                        height: 40,
                                        borderBottom: "none",
                                    }}
                                >
                                    Name
                                </TableCell>
                            </TableRow>
                        </TableHead> */}
              <TableBody>
                {metadataTagZones.map((object: any, index: number) => {
                  return (
                    <TableRow
                      key={object.id}
                      sx={{ height: 40, borderBottom: "none" }}
                    >
                      <TableCell
                        sx={{
                          padding: "8px 8px",
                          height: 40,
                          borderBottom: "none",
                        }}
                      >
                        <div
                          key={object.label}
                          style={{
                            height: 25,
                            width: 25,
                            background: `${object.line_color}`,
                            borderRadius: 4,
                            margin: "0 auto",
                          }}
                        ></div>
                      </TableCell>
                      <TableCell
                        sx={{
                          padding: "8px 8px",
                          height: 40,
                          borderBottom: "none",
                        }}
                      >
                        <div>
                          {object.name}
                          &nbsp;
                          {object.description && (
                            <Tooltip
                              title={object.description}
                              placement="top"
                              sx={{
                                fontSize: "15px",
                                fontFamily: "mulish",
                              }}
                            >
                              <InfoOutlinedIcon fontSize="small"></InfoOutlinedIcon>
                            </Tooltip>
                          )}
                        </div>
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
      )}
      {metadataTagZones.length === 0 && (
        <div className="pl-[45px] pt-[62px]">
          <p className="font-mulish text-[16px]">No Metadata Tag Zones added</p>
        </div>
      )}
    </div>
  );
};
